import { render, staticRenderFns } from "./Aushome.vue?vue&type=template&id=246f837a&scoped=true"
import script from "./Aushome.vue?vue&type=script&lang=js"
export * from "./Aushome.vue?vue&type=script&lang=js"
import style0 from "./Aushome.vue?vue&type=style&index=0&id=246f837a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246f837a",
  null
  
)

export default component.exports